module.exports = require("@wordpress/hooks");